export default import.meta.ROLLUP_FILE_URL_fN3GBDImFL4syCUWbqabiA;